import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import DataTable from "../components/datatable/datatable";
import { Backdrop, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));
export default function DataEditor({title, model_name, ...props}) {
    const classes = useStyles();
    const tableRef = useRef();
    const [loading, setLoading] = useState(false)
    // const [tasks, setTasks] = useState([])

    // useEffect(() => {
    // }, [title, model_name])

    return (
        <div className={classes.root}>

            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={3} justify="center">
                
                <Grid item xs={12}>
                    <DataTable
                        // tableName = 'task_management'
                        modelName = {model_name}
                        title={title}
                        ref={tableRef}
                    />
                </Grid>
            </Grid>
        </div>
    );
}